<template>
  <div class="RB_footer">
      <div class="inner">
          <div class="top">
              <div class="left">
                  <div class="logo"><img src="/statics/images/index/footer_logo.png" alt=""></div>
                  <ul>
                      <li>
                          <div class="icon"><img src="/statics/images/index/tel.png" alt=""></div>
                          <div>
                              <span class="title">咨询电话</span>
                              <!-- <span>18732871000</span> -->
                              <span>17831807666</span>
                          </div>
                      </li>
                      <li>
                          <div class="icon"><img src="/statics/images/index/address.png" alt=""></div>
                          <div>
                              <span class="title">办公地址</span>
                              <span> 河北省衡水市故城县郑口高速口西一公里路北</span>
                          </div>
                      </li>
                      <li>
                          <div class="icon"><img src="/statics/images/index/email.png" alt=""></div>
                          <div>
                              <span class="title">邮箱</span>
                              <span>yixinglong@139.com</span>
                          </div>
                      </li>
                  </ul>
              </div>
              <div class="right">
                  <!-- <div class="wx">
                      <span>微信公众号</span>
                      <div class="pic"><img src="/statics/images/index/gongzhong.jpg" alt=""></div>
                  </div> -->
                  <div class="gf">
                      <span>官方二维码</span>
                      <div class="pic"><img src="/statics/images/index/wangzhan.png" alt=""></div>
                  </div>
              </div>
          </div>
          <div class="bottom">
              <span>版权所有：亿兴隆通风设备（河北）有限公司</span>  
              <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：冀ICP备2022014020号-1</a>
          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>